/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/modal/modal.interface.ts"/>
///<reference path="../../../../components/common/identity.service.ts"/>
///<reference path="../../../../components/busy/busy.service.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>

module Meevo.Plugins.Reports {

  import BusyService = Meevo.Components.Busy.BusyService
  import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

  const hasProductFilter = (item: DP005ProductManufecturer | DP005ProductCategory) => item.products instanceof Array && item.products.length > 0;
  const updateSelectValue = (item: DP005ProductManufecturer | DP005ProductCategory) => item.selected = item.products.filter((product) => product.selected).length > 0;

  class InfinityProductMover implements ng.IComponentController {


    static $inject = [
      '$scope',
      'meevo.components.busy.BusyService',
      'meevo.components.common.IdentityService',
      'meevo.components.common.DataService',
    ];

    criteria: _.Dictionary<any>[];
    parameterNames: string[];
    model: _.Dictionary<any>;

    allSelected: boolean;
    products: IReportDP005Product[];
    manufacturers: DP005ProductManufecturer[];
    categories: DP005ProductCategory[];


    constructor(protected $scope: ng.IScope,
                protected busyService: BusyService,
                private identityService: Meevo.Components.Common.IdentityService,
                private dataService: Meevo.Components.BaseClasses.IDataService) {
      this.onProductsChanged = this.onProductsChanged.bind(this);
      this.onValueChanged = this.onValueChanged.bind(this);

      this.manufacturers = [];
      this.categories = [];
      this.products = [];
    }


    $onInit() {
      this.allSelected = true;

      this.model[this.parameterNames[0]] = [];
      this.model[this.parameterNames[1]] = [];
      this.model[this.parameterNames[2]] = [];

      this.$scope.$watch(() => this.criteria, (newValue) => {
        if (typeof newValue === 'object' && Object.keys(newValue).length > 0) {
          this.loadList();
        }
      }, true);

    }

    loadList() {
      this.busyService.start();
      this.dataService.getListPaged<IReportDP005Product, any>(`report/DP005Product`, {
        criteria: {
          businessTypeList: [this.identityService.businessTypeId],
          locationList: [this.identityService.locationId],
          hierarchyId: null,
          branchId: null,
          objectStateEnumList: [ObjectStateEnum.Active],
          displayName: null,
          fieldOrderBy: 'DisplayName',
          orderAscDesc: 'Ascending',
          ...this.criteria
        },
        itemsPerPage: 50000
      }).then((list) => this.loadMatchingProducts(list))
        .finally(() => this.busyService.stop())
    }

    loadMatchingProducts(list: IReportDP005Product[]) {
      this.manufacturers = [];
      this.categories = [];
      this.products = list;

      if (list.length === 0) return;

      for (const product of list) {
        if (product.dP005ProductCategories.length === 0
          || product.dP005ProductManufecturers.length === 0) continue;

        // generate additional arrays with links to each other for better performance
        this.generateProductCategories(this.categories, product);
        this.generateManufacturers(this.manufacturers, product);
        product.selected = true;
      }

      this.manufacturers = _(this.manufacturers)
        .chain()
        .sortBy((manufacturer) => manufacturer.displayName)
        .uniq(true, (manufacturer) => manufacturer.manufacturer_TId)
        .value();
      this.categories = _(this.categories)
        .chain()
        .sortBy((category) => category.displayName)
        .uniq(true, (category) => category.cat_TId)
        .value();

      this.updateModelsValues();
    }

    protected generateProductCategories(categories: DP005ProductCategory[], product: IReportDP005Product): void {
      product.dP005ProductCategories.forEach(prodCategory => {
        const existingCategory = categories
          .find(category => category.cat_TId === prodCategory.cat_TId);

        if (existingCategory) {
          // replace related object with existed to have 1 linked object
          product.dP005ProductCategories.splice(
            product.dP005ProductCategories.indexOf(prodCategory),
            1,
            existingCategory
          );
          existingCategory.product_TIds.push(product.product_TId);
          existingCategory.products.push(product);
          return;
        }
        prodCategory.product_TIds = [product.product_TId];
        prodCategory.products = [product];
        prodCategory.selected = true;

        categories.push(prodCategory);
      });
    }

    protected generateManufacturers(manufacturers: DP005ProductManufecturer[], product: IReportDP005Product): void {
      product.dP005ProductManufecturers.forEach((manufacture) => {
        const existingManufacture = manufacturers.find(row => {
          return row.manufacturer_TId === manufacture.manufacturer_TId;
        });

        if (existingManufacture) {
          // replace related object with existed to have 1 linked object
          product.dP005ProductManufecturers.splice(
            product.dP005ProductManufecturers.indexOf(manufacture),
            1,
            existingManufacture
          );
          existingManufacture.product_TIds.push(product.product_TId);
          existingManufacture.products.push(product);
          return;
        }

        manufacture.product_TIds = [product.product_TId];
        manufacture.products = [product];
        manufacture.selected = true;

        manufacturers.push(manufacture);
      });
    }

    updateAllSelectedState(value: boolean) {
      this.allSelected = value;

      if (value) {
        this.products.forEach((model: any) => {
          model.selected = true;
        });
        this.manufacturers.forEach((model: any) => {
          model.selected = true;
        });
        this.categories.forEach((model: any) => {
          model.selected = true;
        });

        this.updateModelsValues();
      }
    }

    onValueChanged(model: DP005ProductCategory | DP005ProductManufecturer, modelSelected: boolean) {
      // update product selected state
      for (const product of model.products) {
        product.selected = modelSelected;
      }

      if (model.manufacturer_TId) {
        // update related products
        for (const product of model.products) {
          product.dP005ProductCategories
            .filter(hasProductFilter)
            .forEach(updateSelectValue);
        }
      } else {
        // update related manufacturers
        for (const product of model.products) {
          product.dP005ProductManufecturers
            .filter(hasProductFilter)
            .forEach(updateSelectValue);
        }
      }

      this.updateModelsValues();
    }

    onProductsChanged(product: IReportDP005Product, modelSelected: boolean) {
      // update the selected state for the product categories and manufacturers
      product.dP005ProductCategories
        .filter(hasProductFilter)
        .forEach(updateSelectValue);

      product.dP005ProductManufecturers
        .filter(hasProductFilter)
        .forEach(updateSelectValue);

      this.updateModelsValues();
    }

    updateModelsValues() {
      this.model[this.parameterNames[0]] = this.categories
        .filter((row) => row.selected)
        .map((category) => category.cat_TId);
      this.model[this.parameterNames[1]] = this.manufacturers
        .filter((row) => row.selected)
        .map((manufacture) => manufacture.manufacturer_TId);
      this.model[this.parameterNames[2]] = this.products
        .filter((row) => row.selected)
        .map((product) => {
          const alreadySelectedModel = this.products
            .find((row) => row.product_TId === product.product_TId);

          return {
            barCode: product.barCode,
            productDisplayName: product.productDisplayName,
            product_TId: product.product_TId,
            sku: product.sku,
            variantDisplayName: product.variantDisplayName,
            variant_TId: product.variant_TId,
            generalDisplayName: product.generalDisplayName,
            numberOfLabels: alreadySelectedModel ? alreadySelectedModel.numberOfLabels : 0
          }
        });
    }
  }


  angular.module('meevo.plugins.reports')
    .component('infinityProductMover', <angular.IComponentOptions>{
      templateUrl: 'app/plugins/reports/components/infinity-product-mover/infinity-product-mover.html',
      controller: InfinityProductMover,
      controllerAs: '$ctrl',
      bindings: {
        criteria: '<',
        products: '=',
        model: '<',
        parameterNames: '<'
      }
    });

}
